import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthSessionApiService, LivenessQrApiService} from '@npck/auth-frontend-api';
import {AnalyticsService} from '@npck/libs/analytics-sdk';
import {RouterService, rxSpinner, Spinner} from '@npck/libs/commons';
import {mergeMap} from 'rxjs';
import {AuthHolderService} from '../../../domain/auth-holder.service';
import {TEMP_REDIRECT_URL} from '../../../domain/constants';
import {QR_ID} from '../../../domain/query-param.keys';
import {AUTH_VIDEO_QR_STARTED} from '../../../infra/analytics-events';
import {Path} from '../../../path';

@Component({
    templateUrl: 'qr-info.component.html',
    styleUrls: ['qr-info.component.scss'],
    standalone: false,
})
export class QrInfoComponent {
    QrInfoType = QrInfoType;
    Spinner = Spinner;
    qrId: string;
    type: QrInfoType;

    constructor(
        private activatedRoute: ActivatedRoute,
        private livenessQrApiService: LivenessQrApiService,
        private authHolderService: AuthHolderService,
        private routerService: RouterService,
        private authSessionApiService: AuthSessionApiService,
        private analyticsService: AnalyticsService,
    ) {
        const typeFromData = this.activatedRoute.snapshot.data.type;
        const typeFromState = this.routerService.getState<boolean>('type');
        this.type = typeFromState || typeFromData;
        this.qrId = this.activatedRoute.snapshot.paramMap.get(QR_ID);
        authHolderService.storeLivenessQrId(this.qrId);
    }

    navigateToLivenessQr(): void {
        this.livenessQrApiService.scanLivenessQr(this.qrId)
            .pipe(
                rxSpinner('scanQr'),
                mergeMap(response => {
                    this.authHolderService.storeOauthSessionId(response.sessionId);
                    this.authHolderService.storeFirstFactorToken(response.token);
                    this.authHolderService.storeBiometryVendor(response.biometryVendor);
                    this.authHolderService.storeLivenessQrIin(response.iin);
                    this.authHolderService.storeQrBlockTime(response.blockTimeMinutes);
                    return this.authSessionApiService.authSessionGetData({oauthSessionId: response.sessionId});
                }),
            )
            .subscribe({
                next: data => {
                    this.authHolderService.storeOauthSessionData(data);
                    this.analyticsService.setUserId(data.iinEncrypted);
                    this.analyticsService.capture(AUTH_VIDEO_QR_STARTED, {
                        qr_id: this.qrId,
                        qr_bool: true,
                    });
                    this.routerService.navigate(`${Path.LIVENESS_QR}/${this.qrId}`);
                },
                error: () => window.location.replace('https://id.npck.kz/'),
            });
    }

    cancelAndNavigateToLanding(): void {
        this.livenessQrApiService.scanLivenessQr(this.qrId)
            .pipe(
                rxSpinner('scanQr'),
                mergeMap(response => {
                    this.authHolderService.storeFirstFactorToken(response.token);
                    return this.livenessQrApiService.cancelLivenessQr(this.qrId);
                }),
            )
            .subscribe({
                /* TODO navigate to landing */
                next: () => window.location.replace(TEMP_REDIRECT_URL),
                error: () => window.location.replace(TEMP_REDIRECT_URL),
            });
    }
}

export enum QrInfoType {
    WARNING = 'WARNING',
    SUCCEEDED = 'SUCCEEDED'
}
